import React from "react";
import ErrorPage from "../Notification/Error";

function Address({ props }) {
  const {
    update,
    onChange,
    province,
    onSelect,
    city,
    district,
    area,
    isError,
    loading,
  } = props;

  return (
    <div className="mb-10 lg:w-3/4">
      <div className="grid grid-cols-1 lg:grid-cols-2 grid-rows-1 lg:gap-20 ">
        <div name="address-form" className="mb-6">
          <p className="login-title-form mb-3 text-xl lg:text-2xl">
            Alamat Sesuai KTP
          </p>
          <input
            disabled={loading}
            value={update.alamat}
            onChange={onChange}
            name="alamat"
            className={`${
              loading ? "input-disabled" : "form-input"
            } outline-none w-full p-3`}
            placeholder="Masukkan alamat sesuai ktp anda"
          />
          {isError
            ? isError.length > 0
              ? isError
                  .filter((it) => it.type === "alamat")
                  .map((its, idx) => (
                    <ErrorPage
                      key={idx}
                      props={{ idx, message: its.message }}
                    />
                  ))
              : null
            : null}
        </div>
        <div name="poscode-form" className="mb-6">
          <p className="login-title-form mb-3 text-xl lg:text-2xl">Kode Pos</p>
          <input
            disabled
            value={update.kodepos ? update.kodepos : ""}
            onChange={onChange}
            name="kodepos"
            className={`input-disabled outline-none w-full p-3`}
            placeholder="Masukkan kode pos"
          />
          {isError
            ? isError.length > 0
              ? isError
                  .filter((it) => it.type === "kodepos")
                  .map((its, idx) => (
                    <ErrorPage
                      key={idx}
                      props={{ idx, message: its.message }}
                    />
                  ))
              : null
            : null}
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 grid-rows-1 lg:gap-20 ">
        <div name="province-form" className="mb-6">
          <p className="login-title-form mb-3 text-xl lg:text-2xl">Provinsi</p>
          <select
            disabled={loading}
            onChange={onSelect}
            value={update.provinsi ? update.provinsi : 0}
            name="provinsi"
            className="form-input outline-none w-full p-3 pr-4"
            placeholder="Pilih provinsi anda"
          >
            <option className="colors-gray" disabled selected value={0}>
              Pilih provinsi anda
            </option>
            {province.map((it, idx) => (
              <option key={idx} value={it.provinsi}>
                {it.provinsi}
              </option>
            ))}
          </select>

          {isError
            ? isError.length > 0
              ? isError
                  .filter((it) => it.type === "provinsi")
                  .map((its, idx) => (
                    <ErrorPage
                      key={idx}
                      props={{ idx, message: its.message }}
                    />
                  ))
              : null
            : null}
        </div>
        <div name="city-form" className="mb-6">
          <p className="login-title-form mb-3 text-xl lg:text-2xl">
            Kabupaten / Kota
          </p>
          <select
            disabled={loading}
            onChange={onSelect}
            value={update.kota ? update.kota : 0}
            name="kota"
            className={`${
              loading ? "input-disabled" : "form-input"
            } outline-none w-full p-3`}
            placeholder="Harap pilih provinsi terlebih dahulu"
          >
            <option className="colors-gray" disabled selected value={0}>
              Harap pilih provinsi terlebih dahulu
            </option>
            {city
              ? city.map((it, idx) => (
                  <option key={idx} value={it.kabupaten}>
                    {it.kabupaten}
                  </option>
                ))
              : null}
          </select>

          {isError
            ? isError.length > 0
              ? isError
                  .filter((it) => it.type === "kota")
                  .map((its, idx) => (
                    <ErrorPage
                      key={idx}
                      props={{ idx, message: its.message }}
                    />
                  ))
              : null
            : null}
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 grid-rows-1 lg:gap-20 ">
        <div name="district-form" className="mb-6">
          <p className="login-title-form mb-3 text-xl lg:text-2xl">Kecamatan</p>
          <select
            disabled={loading}
            onChange={onSelect}
            value={update.kecamatan ? update.kecamatan : 0}
            name="kecamatan"
            className={`${
              loading ? "input-disabled" : "form-input"
            } outline-none w-full p-3`}
            placeholder="Harap pilih kabupaten / kota terlebih dahulu"
          >
            <option className="colors-gray" disabled selected value={0}>
              Harap pilih kabupaten / kota terlebih dahulu
            </option>
            {district
              ? district.map((it, idx) => (
                  <option key={idx} value={it.kecamatan}>
                    {it.kecamatan}
                  </option>
                ))
              : null}
          </select>

          {isError
            ? isError.length > 0
              ? isError
                  .filter((it) => it.type === "kecamatan")
                  .map((its, idx) => (
                    <ErrorPage
                      key={idx}
                      props={{ idx, message: its.message }}
                    />
                  ))
              : null
            : null}
        </div>
        <div name="kelurahan-form" className="mb-1">
          <p className="login-title-form mb-3 text-xl lg:text-2xl">Kelurahan</p>
          <select
            disabled={loading}
            onChange={onSelect}
            value={update.kelurahan ? update.kelurahan : 0}
            name="kelurahan"
            className={`${
              loading ? "input-disabled" : "form-input"
            } outline-none w-full p-3`}
            placeholder="Harap pilih kecamatan terlebih dahulu"
          >
            <option className="colors-gray" disabled selected value={0}>
              Harap pilih kecamatan terlebih dahulu
            </option>
            {area
              ? area.map((it, idx) => (
                  <option key={idx} value={it.kelurahan}>
                    {it.kelurahan}
                  </option>
                ))
              : null}
          </select>

          {isError
            ? isError.length > 0
              ? isError
                  .filter((it) => it.type === "kelurahan")
                  .map((its, idx) => (
                    <ErrorPage
                      key={idx}
                      props={{ idx, message: its.message }}
                    />
                  ))
              : null
            : null}
        </div>
      </div>
    </div>
  );
}

export default Address;
